import React, { useContext } from "react";
import { Card, CardContent, CardHeader, CardMedia, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { format } from "date-fns";
import MoreVertIcon from '@mui/icons-material/MoreVert';

import { Link } from "react-router-dom";
import { AppContext } from "../Store";

const NewsCard: React.FC<any> = ({ article }) => {

  const context = useContext(AppContext);
  const { userContext } = context;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };


  return (
    <Card variant="outlined">
      <CardHeader
        action={
          userContext.isTeacher() && article.editUrl &&
          <IconButton aria-label="settings" onClick={handleClick} >
            <MoreVertIcon />
          </IconButton>
        }
        title={article.title}
        subheader={format(new Date(article.date), "yyyy-MMM-dd")}
      />
      {
        userContext.isTeacher() &&
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          {/* Items added in the portal have no Google Form response to edit */}
          {article.editUrl && <MenuItem>
            <Link to={article.editUrl} target="_blank">Edit</Link>
          </MenuItem>}
        </Menu>
      }
      {article.photoUrl && <CardMedia
        component="img"
        sx={{
          objectFit: "contain",
          width: "100%",
          height: "auto",
        }}
        image={article.photoUrl} />}
      <CardContent>
        <Typography color="text.secondary">{article.content}</Typography>
      </CardContent>
    </Card>
  );
};

export default NewsCard;
